import { Grid } from '@mui/material';

function FormGrid({ children }){
  return(
    <Grid container justifyContent='center'>
      <Grid container item spacing={2} xs={12} md={12} lg={12} xl={8}>
        {children}
      </Grid>
    </Grid>
  )
} export default FormGrid;